import { DebugLogger } from "@ng-mw/shared-react-components"
import React from "react"
import { Route } from "react-router-dom"
import NotFound from "@modules/shared/NotFound"
import PathNames from "./const/PathNames"
import * as tracking from "@app/tracking"

// These are loaded instantly anyway so there is no reason to lazy load them:
import HomePage from "@modules/home/pages/HomePage"
import AppGlobalSettings from "./AppGlobalSettings"

import {
    AccessibilityPlaygroundPage,
    LoggerPlaygroundPage,
    BestBuyPage,
    BusinessInformationPage,
    BusinessOrdersPage,
    BusinessUsersPage,
    BusinessRegistrationPage,
    CampaignPage,
    CartPage,
    CategoryPage,
    ChatPage,
    CheckoutPage,
    ClimateHomePage,
    ClimateLevelThreePage,
    ClimateLevelTwoPage,
    ClimateProductGroupsPage,
    ComponentPlaygroundPage,
    ContactDetailsPage,
    CouponsPage,
    CustomerServicePage,
    DebugPage,
    DietHomePage,
    DietLevelFourPage,
    DietLevelOnePage,
    DietLevelThreePage,
    DietLevelTwoPage,
    DietMacroNutrientsPage,
    DietOverviewPage,
    DinnerSuggestionsPreferencesPage,
    NotificationSettingsPage,
    OrderHistoryPage,
    OrderItemPage,
    PurchaseComplaintPage,
    PurchaseHistoryPage,
    RecipesHomePage,
    MyRecipesPage,
    SavingsPage,
    SearchPage,
    ShoppingListPage,
    ShoppingListsHomePage,
    TrumfAssociatesPage,
    TrumfBankCardsPage,
    TrumfCardsPage,
    TrumfChainConsentsPage,
    TrumfAnalyticalConsentPage,
    TrumfMemberPage,
    TrumfProfilePage,
    UseBonusPage,
    UseBonusToBankPage,
    UseBonusToCharityPage,
    UserManageBiometricsPage,
    UserProfilePage,
    doPreload,
    CouponsPageStandalone,
} from "./routeLoaders"

window.performanceTimings.js = performance.now()
DebugLogger.log(
    "Load-order-debug: (routes.js executed) Script load time:",
    window.performanceTimings.js,
    "ms",
)
console.timeLog("Load-order-debug-TIMER")
tracking.startUpMetricsJs()

let i = 0

export default [
    <Route
        path={PathNames.Home}
        key={i++}
        component={HomePage}
        exact
    />,
    <Route
        path={PathNames.Debug}
        key={i++}
        component={DebugPage}
        exact
    />,
    <Route
        path={PathNames.AccessibilityPlayground}
        key={i++}
        component={AccessibilityPlaygroundPage}
        exact
    />,
    <Route
        path={PathNames.LoggerPlayground}
        key={i++}
        component={LoggerPlaygroundPage}
        exact
    />,
    <Route
        path={PathNames.ComponentPlayground}
        key={i++}
        component={ComponentPlaygroundPage}
        exact
    />,
    <Route
        path={PathNames.Category}
        key={i++}
        component={CategoryPage}
    />,
    <Route
        path={PathNames.Cart}
        key={i++}
        component={CartPage}
        exact
    />,
    <Route
        path={PathNames.Checkout}
        key={i++}
        component={CheckoutPage}
        exact
    />,
    <Route
        path={PathNames.ContactDetails}
        key={i++}
        component={ContactDetailsPage}
        exact
    />,
    <Route
        path={PathNames.TrumfProfile}
        key={i++}
        component={TrumfProfilePage}
        exact
    />,
    <Route
        path={PathNames.TrumfProfile}
        key={i++}
        component={TrumfProfilePage}
        exact
    />,
    <Route
        path={PathNames.TrumfMember}
        key={i++}
        component={TrumfMemberPage}
        exact
    />,
    <Route
        path={PathNames.TrumfBankCards}
        key={i++}
        component={TrumfBankCardsPage}
        exact
    />,
    <Route
        path={PathNames.TrumfTrumfCards}
        key={i++}
        component={TrumfCardsPage}
        exact
    />,
    <Route
        path={PathNames.TrumfChainConsents}
        key={i++}
        component={TrumfChainConsentsPage}
        exact
    />,
    <Route
        path={PathNames.TrumfAnalyticalConsent}
        key={i++}
        component={TrumfAnalyticalConsentPage}
        exact
    />,
    <Route
        path={PathNames.TrumfAssociates}
        key={i++}
        component={TrumfAssociatesPage}
        exact
    />,
    <Route
        path={PathNames.UserManageBiometrics}
        key={i++}
        component={UserManageBiometricsPage}
        exact
    />,
    <Route
        path={PathNames.NotificationSettings}
        key={i++}
        component={NotificationSettingsPage}
        exact
    />,
    <Route
        path={PathNames.DinnerSuggestionsPreferences}
        key={i++}
        component={DinnerSuggestionsPreferencesPage}
        exact
    />,
    <Route
        path={PathNames.ShoppingListsHome}
        key={i++}
        component={ShoppingListsHomePage}
        exact
    />,
    <Route
        path={PathNames.ShoppingListPage}
        key={i++}
        component={ShoppingListPage}
    />,
    <Route
        path={PathNames.Savings}
        key={i++}
        component={SavingsPage}
        exact
    />,
    <Route
        path={PathNames.BestBuy}
        key={i++}
        component={BestBuyPage}
        exact
    />,
    <Route
        path={PathNames.Campaign}
        key={i++}
        component={CampaignPage}
        exact
    />,
    <Route
        path={PathNames.Benefits}
        key={i++}
        component={CouponsPage}
        exact
    />,
    <Route
        path={PathNames.OrderItem}
        key={i++}
        component={OrderItemPage}
    />,
    <Route
        path={PathNames.OrderHistory}
        key={i++}
        component={OrderHistoryPage}
        exact
    />,
    <Route
        path={PathNames.PurchaseHistory}
        key={i++}
        exact
    >
        <PurchaseHistoryPage />
    </Route>,
    <Route
        path={PathNames.PurchaseComplaint}
        key={i++}
        component={PurchaseComplaintPage}
        exact
    />,
    <Route
        path={PathNames.UseBonus}
        key={i++}
        component={UseBonusPage}
        exact
    />,
    <Route
        path={PathNames.UseCoupons}
        key={i++}
        component={CouponsPageStandalone}
        exact
    />,
    <Route
        path={PathNames.UseBonusToCharity}
        key={i++}
        component={UseBonusToCharityPage}
        exact
    />,
    <Route
        path={PathNames.UseBonusToBank}
        key={i++}
        component={UseBonusToBankPage}
        exact
    />,
    <Route
        path={PathNames.UserProfile}
        key={i++}
        component={UserProfilePage}
        exact
    />,
    <Route
        path={PathNames.BusinessInformation}
        key={i++}
        component={BusinessInformationPage}
        exact
    />,
    <Route
        path={PathNames.BusinessOrders}
        key={i++}
        component={BusinessOrdersPage}
        exact
    />,
    <Route
        path={PathNames.BusinessUsers}
        key={i++}
        component={BusinessUsersPage}
        exact
    />,
    <Route
        path={PathNames.BusinessRegistration}
        key={i++}
        component={BusinessRegistrationPage}
        exact
    />,
    <Route
        path={PathNames.MyRecipes}
        key={i++}
        component={MyRecipesPage}
        exact
    />,
    <Route
        path={PathNames.RecipesHome}
        key={i++}
        component={RecipesHomePage}
        exact
    />,
    <Route
        path={PathNames.ChatPage}
        key={i++}
        component={ChatPage}
        exact
    />,
    <Route
        path={PathNames.CustomerServicePage}
        key={i++}
        component={CustomerServicePage}
        exact
    />,
    <Route
        path={PathNames.DietOverview}
        key={i++}
        component={DietOverviewPage}
        exact
    />,
    <Route
        path={PathNames.DietMacroNutrients}
        key={i++}
        component={DietMacroNutrientsPage}
        exact
    />,
    <Route
        path={PathNames.DietLevelOne}
        key={i++}
        component={DietLevelOnePage}
        exact
    />,
    <Route
        path={PathNames.DietLevelTwo}
        key={i++}
        component={DietLevelTwoPage}
        exact
    />,
    <Route
        path={PathNames.DietLevelThree}
        key={i++}
        component={DietLevelThreePage}
        exact
    />,
    <Route
        path={PathNames.DietLevelFour}
        key={i++}
        component={DietLevelFourPage}
        exact
    />,
    <Route
        path={PathNames.DietHome}
        key={i++}
        component={DietHomePage}
        exact
    />,
    <Route
        path={PathNames.ClimateProductGroups}
        key={i++}
        component={ClimateProductGroupsPage}
        exact
    />,
    <Route
        path={PathNames.ClimateLevelTwo}
        key={i++}
        component={ClimateLevelTwoPage}
        exact
    />,
    <Route
        path={PathNames.ClimateLevelThree}
        key={i++}
        component={ClimateLevelThreePage}
        exact
    />,
    <Route
        path={PathNames.ClimateHome}
        key={i++}
        component={ClimateHomePage}
        exact
    />,
    <Route
        path={PathNames.Search}
        key={i++}
        component={SearchPage}
        exact
    />,
    <Route
        key={i++}
        render={({ location }) => (
            <NotFound
                homeUrl={PathNames.Search}
                currentUrl={location.pathname}
            />
        )}
        exact
    />,
]

if (AppGlobalSettings.aggressivePreload) {
    doPreload()
} else {
    setTimeout(doPreload, 7000) // delay preloading for 7 seconds
}
